import React from "react";
import { PlusIcon } from "lucide-react";
import type { IconComponent } from "../../types/ui";
import { HistoryRow } from "../../types/hr";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";
import { EmptyState } from "../ui/EmptyState";
export interface HistoryColumn {
  key: string;
  label: string;
  align?: 'right';
}
interface HistoryCardProps {
  title: string;
  icon: IconComponent;
  columns: HistoryColumn[];
  rows: HistoryRow[];
  emptyText: string;
  markCurrent?: boolean;
  onAdd: () => void;
}
export function HistoryCard({
  title,
  icon,
  columns,
  rows,
  emptyText,
  markCurrent,
  onAdd
}: HistoryCardProps) {
  return <Card title={title} icon={icon} action={<Button variant="ghost" size="sm" icon={PlusIcon} onClick={onAdd} data-id="element-228" data-mp="wjx13kv4ddj8">
          Add Entry
        </Button>} bodyClassName="pb-2" data-id="element-227" data-mp="11k1h79s4868x">
      {rows.length === 0 ? <div className="px-6 pb-4" data-id="element-229" data-mp="2vtvec6idgwtg">
          <EmptyState icon={icon} title={emptyText} description="Use “Add Entry” to record the first one." compact data-id="element-230" data-mp="2qwmr3rida2lc" />
        </div> : <div className="overflow-x-auto" data-id="element-231" data-mp="24nq9ccjw2tj2">
          <table className="w-full min-w-[640px] text-left text-sm" data-id="element-232" data-mp="24qvxnpkp1rdq">
            <thead data-id="element-233" data-mp="29p75jurfhrtb">
              <tr className="border-y border-slate-100 bg-canvas/70" data-id="element-234" data-mp="29l9m180xuy8w">
                {columns.map(c => <th key={c.key} scope="col" className={`whitespace-nowrap px-6 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-muted ${c.align === 'right' ? 'text-right' : ''}`} data-id="element-235" data-mp="1usg6jmlo2i48">
                    {c.label}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-236" data-mp="2sdkmkv84ek3u">
              {rows.map((row, i) => <tr key={`${title}-${i}`} className="transition-colors hover:bg-azure/[0.03]" data-id="element-237" data-mp="2do67d6hv58gj" data-mpi={i}>
                  {columns.map((c, ci) => <td key={c.key} className={`whitespace-nowrap px-6 py-3 ${ci === 0 ? 'font-medium text-navy' : 'text-slate-700'} ${c.align === 'right' ? 'text-right tabular-nums' : ''}`} data-id="element-238" data-mp="2imhjxozjlx2g" data-mpi={ci}>
                      {ci === 0 && markCurrent ? <span className="inline-flex items-center gap-2" data-id="element-239" data-mp="3b6g44qx1hvob">
                          <span className={`h-2 w-2 rounded-full ${i === 0 ? 'bg-emerald-500 ring-4 ring-emerald-500/15' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-240" data-mp="3l026ybr7wjaa" />
                          {row[c.key] || '—'}
                          {i === 0 && <span className="sr-only" data-id="element-241" data-mp="3c206bxbebsnj">(current)</span>}
                        </span> : row[c.key] || '—'}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>}
    </Card>;
}